import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import he from "./locales/he.json";
import ru from "./locales/ru.json";

export const SUPPORTED_LANGS = ["ru", "en", "he"] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

export const LANG_META: Record<Lang, { native: string; short: string; dir: "ltr" | "rtl" }> = {
  ru: { native: "Русский", short: "RU", dir: "ltr" },
  en: { native: "English", short: "EN", dir: "ltr" },
  he: { native: "עברית", short: "HE", dir: "rtl" },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
      he: { translation: he },
    },
    fallbackLng: "ru",
    supportedLngs: SUPPORTED_LANGS,
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      // Persist a manual choice; otherwise sniff navigator.language. We avoid
      // anything that needs a cookie (sites embedded in iframes) and keep
      // everything client-side.
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "nifgash.lang",
      caches: ["localStorage"],
    },
  });

/**
 * Apply the current language's direction (LTR/RTL) and `lang` attribute to
 * the document root. Called from <App /> on mount and after every change so
 * Hebrew flips the whole layout right-to-left automatically.
 */
export function applyLangToDocument(lang: string) {
  const known = (SUPPORTED_LANGS as readonly string[]).includes(lang) ? (lang as Lang) : "ru";
  document.documentElement.lang = known;
  document.documentElement.dir = LANG_META[known].dir;
}

export default i18n;
